import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { usePathBuilder } from '../../core/routing/hooks/use-path-builder';
import { PageContainer } from '../../modules/page-container/page-container';
import { Scanner } from './components/scanner';

export const Overview: React.FC = () => {
  const { t } = useTranslation();
  const { searchArticlePath } = usePathBuilder();
  const navigate = useNavigate();

  return (
    <PageContainer documentTitle={t('scan.documentTitle')}>
      <Scanner
        onArticleIdDetect={(articleId) => {
          navigate(searchArticlePath(articleId));
        }}
      />
    </PageContainer>
  );
};
